import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "TreeSelect",
  props: {
    // 树结构数据
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    obj: {
      type: Object,
      required: false,
      default: function _default() {
        return {
          id: "id",
          // ID
          label: "label",
          // 显示名称
          children: "children",
          //子级字段名
          path: "path",
          //路径
          content: "content",
          //描述
          pid: "pid" //父id

        };
      }
    },
    // 配置是否可多选
    multiple: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // 是否展开所有
    expandAll: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // 配置是否可清空选择
    clearable: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // 配置多选时是否将选中值按文字的形式展示
    collapseTags: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // 显示复选框情况下，是否严格遵循父子不互相关联
    checkStrictly: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    //多选是设置点击节点是否可以选中
    checkClickNode: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    //多选时：点击节点展开还是点三角标
    expandClickNode: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // 默认选中的节点key
    defaultKey: {
      type: [Number, String, Array, Object],
      default: function _default() {
        return [];
      }
    },
    size: {
      type: String,
      default: function _default() {
        return "small";
      }
    },
    width: {
      type: String,
      default: function _default() {
        return "100%";
      }
    },
    height: {
      type: String,
      default: function _default() {
        return "300px";
      }
    }
  },
  //上面是父组件可传入参数
  data: function data() {
    return {
      popoverWidth: "100%",
      //下拉框大小
      isShowSelect: false,
      // 是否显示树状选择器
      isShow: true,
      // 是否显示树状选择器
      options: [],
      //select option选项
      returnDatas: [],
      //返回给父组件数组对象
      returnDataKeys: [],
      //返回父组件数组主键值
      filterText: ""
    };
  },
  computed: {
    treeData: function treeData() {
      // 若非树状结构，则转化为树状结构数据
      return JSON.stringify(this.data).indexOf(this.obj.children) !== -1 ? this.data : this.switchTree();
    }
  },
  methods: {
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    init: function init() {
      // eslint-disable-next-line no-undef,no-debugger
      // debugger
      if (this.defaultKey != undefined && this.defaultKey.length > 0) {
        if (this.multiple) {
          // 多选
          if (Object.prototype.toString.call(this.defaultKey).indexOf("Array") != -1) {
            if (Object.prototype.toString.call(this.defaultKey[0]).indexOf("Object") != -1) {
              //对象
              this.setDatas(this.defaultKey);
            } else if (Object.prototype.toString.call(this.defaultKey[0]).indexOf("Number") != -1 || Object.prototype.toString.call(this.defaultKey[0]).indexOf("String") != -1) {
              this.setKeys(this.defaultKey);
            } else {
              return;
            }
          } else {
            return;
          }
        } else {
          // 单选
          if (Object.prototype.toString.call(this.defaultKey).indexOf("Number") != -1 || Object.prototype.toString.call(this.defaultKey).indexOf("String") != -1 || Object.prototype.toString.call(this.defaultKey).indexOf("Object") != -1) {
            this.setKey(this.defaultKey);
          } else {
            return;
          }
        }
      }
    },
    //下拉框select点击[入口]
    selectClick: function selectClick() {
      this.$nextTick(function () {
        //设置下拉框自适应宽度
        this.popoverWidth = this.$refs.select.$el.clientWidth;
      }); //显示下拉框

      return this.isShowSelect = !this.isShowSelect;
    },
    //单选: 树点击方法
    nodeClick: function nodeClick(data, node) {
      var _this = this;

      if (!this.multiple) {
        //单选
        this.isShowSelect = false;
        this.setKey(node.key);
      } else {
        //多选
        var checkedKeys = this.$refs.tree.getCheckedKeys(); // 所有被选中的节点的 key 所组成的数组数据

        var t = [];
        this.options = checkedKeys.map(function (item) {
          //设置option选项
          var node = _this.$refs.tree.getNode(item); // 所有被选中的节点对应的node


          t.push(node.data);
          return {
            label: node.label,
            value: node.key
          };
        });
        this.returnDataKeys = this.options.map(function (item) {
          return item.value;
        });
        this.returnDatas = t;
      }
    },
    //单选:清空选中
    clean: function clean() {
      this.$refs.tree.setCurrentKey(null); //清除树选中key

      this.returnDatas = null;
      this.returnDataKeys = "";
      this.popoverHide();
    },
    //单选:设置、初始化值 key
    setKey: function setKey(thisKey) {
      this.$refs.tree.setCurrentKey(thisKey);
      var node = this.$refs.tree.getNode(thisKey);
      this.setData(node.data);
    },
    //单选：设置、初始化对象
    setData: function setData(data) {
      this.options = [];
      this.options.push({
        label: data[this.obj.label],
        value: data[this.obj.id]
      });
      this.returnDatas = data;
      this.returnDataKeys = data[this.obj.label];
    },
    //多选:设置、初始化值 keys
    setKeys: function setKeys(thisKeys) {
      var _this2 = this;

      this.$refs.tree.setCheckedKeys(thisKeys);
      this.returnDataKeys = thisKeys;
      var t = [];
      thisKeys.map(function (item) {
        //设置option选项
        var node = _this2.$refs.tree.getNode(item); // 所有被选中的节点对应的node


        t.push(node.data);
        return {
          label: node.label,
          value: node.key
        };
      });
      this.returnDatas = t;
      this.popoverHide();
    },
    //多选:设置、初始化对象
    setDatas: function setDatas(data) {
      var _this3 = this;

      this.$refs.tree.setCheckedNodes(data);
      this.returnDatas = data;
      var t = [];
      data.map(function (item) {
        //设置option选项
        t.push(item[_this3.obj.id]);
      });
      this.returnDataKeys = t;
      this.popoverHide();
    },
    // 多选,删除任一select选项的回调
    removeTag: function removeTag(val) {
      var _this4 = this;

      this.$refs.tree.setChecked(val, false); //设置为未选中

      var node = this.$refs.tree.getNode(val); //获取节点

      if (!this.checkStrictly && node.childNodes.length > 0) {
        this.treeToList(node).map(function (item) {
          if (item.childNodes.length <= 0) {
            _this4.$refs.tree.setChecked(item, false);
          }
        });
      }

      this.nodeClick();
      this.popoverHide();
    },
    //下拉框关闭执行
    popoverHide: function popoverHide() {
      var key = null;
      var data = null;

      if (!this.multiple) {
        key = this.returnDataKeys || "";
        data = this.returnDatas || {};
      } else {
        key = this.returnDataKeys || [];
        data = this.returnDatas || [];
      }

      this.$emit("getValue", key, data);
    },
    // 多选，清空所有勾选
    clearSelectedNodes: function clearSelectedNodes() {
      var checkedKeys = this.$refs.tree.getCheckedKeys(); // 所有被选中的节点的 key 所组成的数组数据

      for (var i = 0; i < checkedKeys.length; i++) {
        this.$refs.tree.setChecked(checkedKeys[i], false);
      }
    },
    //树形转为集合
    treeToList: function treeToList(tree) {
      var queen = [];
      var out = [];
      queen = queen.concat(tree);

      while (queen.length) {
        var first = queen.shift();

        if (first.childNodes) {
          queen = queen.concat(first.childNodes);
        }

        out.push(first);
      }

      return out;
    },
    switchTree: function switchTree() {
      return this.buildTree(this.data, this.defaultValue);
    },
    // 将一维的扁平数组转换为多层级对象
    buildTree: function buildTree(data, id) {
      var _this5 = this;

      var fa = function fa(id) {
        var temp = [];

        for (var i = 0; i < data.length; i++) {
          var n = data[i];

          if (n[_this5.obj.pid] === id) {
            n[_this5.obj.children] = fa(n[_this5.obj.id]);
            temp.push(n);
          }
        }

        return temp;
      };

      return fa(id);
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    isShowSelect: function isShowSelect(val) {
      if (!val) {
        this.popoverHide();
      }

      this.$refs.select.blur();
    },
    treeData: function treeData() {
      var _this6 = this;

      //监听tree数据
      this.$nextTick(function () {
        _this6.init();
      });
    },
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  }
};